import { connect } from 'react-redux';

import { MainTitle, IMainTitleStoreProps, IMainTitleOwnProps } from '../../components/MainTitle';
import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
function mapStateToProps(state: IApplicationState): IMainTitleStoreProps {
  return {
    page: state.page,
    user: state.user,
    total: state.results.total,
    favoriteEntities: state.results.favoriteEntities,
  };
}

export const MainTitleContainer = connect<IMainTitleStoreProps, {}, IMainTitleOwnProps>(mapStateToProps)(MainTitle);
